import React from 'react';
import { motion } from 'framer-motion';
import { PortfolioConfig } from '../types/config';
import BackgroundAnimation from './BackgroundAnimation';
import { HorizontalCarousel } from './ui/HorizontalCarousel';

interface BlogsProps {
  config: PortfolioConfig;
}

const Blogs: React.FC<BlogsProps> = ({ config }) => {
  if(!config.blogs || config.blogs.length === 0) return null;

  const blogItems = config.blogs.map((blog, index) => ({
    id: blog.title,
    title: blog.title,
    description: blog.excerpt,
    image: blog.image,
    date: blog.date,
    readTime: blog.readTime,
    tags: blog.tags,
    url: blog.url,
    type: 'blog' as const
  }));

  return (
    <section id="blogs">
      <HorizontalCarousel
        items={blogItems}
        title="Latest Blog Posts"
        subtitle="Insights and thoughts from my journey"
      />
    </section>
  );
};

export default Blogs; 